import API from "./API";
import Alert from "../stores/alerts";
import app from "../stores/app";
import user from "../stores/user";
import {writable} from "svelte/store";

export const LOADER = {
    NONE: 0,
    PAGE: 1,
    POPUP: 2,
}

const mm = writable(false);

const R = {
    handle: async (func, params, success, failure, loader = 0) => {
        if (loader == LOADER.PAGE) {
            app.showPageLoader();
        } else if (loader == LOADER.POPUP) {
            app.showPopupLoader();
        }

        mm.set(true);
        //const [err, result] = await func(params);
        const result = await func(params);
        mm.set(false);

        if (loader == LOADER.PAGE) {
            app.hidePageLoader();
        } else if (loader == LOADER.POPUP) {
            app.hidePopupLoader();
        }

        if (result.error) {
            if (result.error.code == 'no_login') {
                Alert.warning("Λογαριασμός", "Έχετε αποσυνδεθεί από τον λογαριασμό σας!", () => {
                    user.clearToken();
                    window.location.href = "/";
                });
            }
            failure(result.error);
        } else {
            success(result.data);
        }
    },

    app: {
        login: (data) => API.POST(`login`, data),
        initialize: (data) => API.POST('initialize', data),
    },

    product: {
        index: (data) => API.POST('products', data),
        details: (id) => API.POST(`product/details`, {id}),
        create: (data) => API.POST('product/create', data),
        edit: (data) => API.POST(`product/edit`, data),
        delete: (id) => API.POST('product/delete', {id}),
    },

    order: {
        initialize: () => API.GET(`order/initialize`),
        index: () => API.GET('orders'),
        details: (data) => API.POST(`order/details`, data),
        create: (data) => API.POST('order/create', data),
    },

    document: {
        index: (data) => API.POST('documents', data),
        download: (data) => API.POST('document/download', data),
    },

    account: {
        details: (data) => API.POST(`account/details`, data),
        edit: (data) => API.POST('account/edit', data),
        search: (data) => API.POST('accounts/search', data),
        getEmail: (id) => API.POST(`account/email`, {id}),
        setPassword: (data) => API.POST('account/set-password', data),
    },

    action: {
        request: (data) => API.POST('action/request', data),
        confirm: (hash) => API.POST('action/confirm', {hash}),
    }

};

export default R;
export {mm as requestingStore};